<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-end">
                <div class="col-sm mb-2 mb-sm-0">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-no-gutter">
                            <li class="breadcrumb-item"><router-link class="breadcrumb-link" to="/">Kokpit</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Nadpisy</li>
                        </ol>
                    </nav>
                    <h1 class="page-header-title">Nadpisy (Sender ID)</h1>
                </div>
                <div class="col-sm-auto">
                    <router-link class="btn btn-primary" to="/nadpis/add">
                        <i class="bi-plus-lg me-1"></i> {{ $lang.create }}
                    </router-link>
                </div>
            </div>
        </div>
        <!-- End Page Header -->

        <div class="card shadow-sm border-0">
            <div class="table-responsive">
                <table
                    class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
                    <thead class="thead-light">
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Nazwa nadpisu</th>
                            <th>Status</th>
                            <th class="text-end">Opcje</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="avatar avatar-sm avatar-soft-info avatar-circle me-3">
                                        <i class="bi-chat-quote"></i>
                                    </div>
                                    <span class="h5 mb-0">{{ item.nadpis_name }}</span>
                                </div>
                            </td>
                            <td>
                                <span v-if="item.nadpis_status === 'active' || item.nadpis_status === '1'"
                                    class="badge bg-soft-success text-success rounded-pill">Aktywny</span>
                                <span v-else class="badge bg-soft-warning text-warning rounded-pill">{{
                                    item.nadpis_status || 'Oczekiwanie' }}</span>
                            </td>
                            <td class="text-end">
                                <DeleteConfirm @ok="deletenadpis(item)"></DeleteConfirm>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="items.length === 0" class="card-body text-center py-5">
                <i class="bi-chat-quote display-1 text-muted opacity-25"></i>
                <p class="mt-3">Brak zarejestrowanych nadpisów.</p>
            </div>
        </div>
    </div>
</template>

<script>
import panelApi from '../../api/panel-axios.js';
import appConfig from '../../config.js';
import DeleteConfirm from '../DeleteConfirm.vue';

export default {
    name: 'NadpisIndex',
    components: {
        DeleteConfirm
    },
    data() {
        return {
            items: [],
            loading: false
        }
    },
    methods: {
        load() {
            this.loading = true;
            panelApi.get(appConfig.panelApiPrefix + '/nadpis').then(response => {
                this.items = response.data.data || [];
                this.loading = false;
            }).catch(err => {
                console.error(err);
                this.loading = false;
            });
        },
        deletenadpis(nadpis) {
            panelApi.delete(appConfig.panelApiPrefix + '/nadpis/' + nadpis.nadpis_id).then(response => {
                this.load();
            });
        }
    },
    mounted() {
        if (!['owner', 'manager'].includes(this.$store.getters['app/role'])) {
            this.$router.push('/');
        }
        this.load();
    }
}
</script>

<style scoped>
.avatar-soft-info {
    background-color: rgba(0, 201, 255, 0.1);
    color: #00c8ff;
    width: 2.2rem;
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bg-soft-success {
    background-color: rgba(0, 201, 167, 0.1) !important;
}

.bg-soft-warning {
    background-color: rgba(245, 202, 153, 0.1) !important;
}
</style>